module.exports = __webpack_public_path__ + "images/emoji/link.b32845b64cd15e3587f7.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/link.png
// module id = dtup
// module chunks = 1